module.exports = __webpack_public_path__ + "assets/suitcase.c5bae37a.svg";